import React from 'react';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type TIconIds from 'bz-icons/src/common/type/icon-ids';
import type IconsLoadedStore from 'bz-icons/src/controls/stores/loaded';
import BzIconErrorBoundary from '../../../../common/error-boundary';

export interface IProps {
  id: TIconIds;
  symbol: React.ReactNode;

  iconsLoadedStore?: IconsLoadedStore;
}

@inject('iconsLoadedStore')
@observer
class LazySymbol extends React.Component<IProps> {
  render() {
    if (!this.loaded) {
      return null;
    }
    const { symbol } = this.props;

    return (
      <BzIconErrorBoundary>
        <React.Suspense fallback={null}>{symbol}</React.Suspense>
      </BzIconErrorBoundary>
    );
  }

  @computed
  private get loaded(): boolean {
    const { id, iconsLoadedStore } = this.props;

    return iconsLoadedStore!.loaded.has(id);
  }
}

export default LazySymbol;
